import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ReportsAbstractService } from './reports-abstract.service';
import { GatewayDetailsTableResponse } from '../reports/models/reports';

@Injectable()
export class GatewayPerformanceReportService extends ReportsAbstractService {
  public reportRoute: string = 'gateway_performance_report';

  constructor(protected http: HttpClient) {
    super(http);
    this.route = this.reportRoute;
  }

  // Override to route to details_table instead of filtered_report
  // Normalizes the response to match the Pager interface expected by ReportTableV2Component
  getFilteredReport(params: object, route: string = ''): Observable<GatewayDetailsTableResponse> {
    const targetRoute = route ? '/' + route + '/' : '/details_table/';
    return this.http.post<GatewayDetailsTableResponse>(this.route + targetRoute, params).pipe(
      map((data: GatewayDetailsTableResponse) => {
        const results = data.results || [];
        const hasSummaryRow = data.summary_row != null;
        return {
          results: results,
          summary_row: data.summary_row || null,
          has_total_row: data.has_total_row != null ? data.has_total_row : hasSummaryRow,
          count: data.count != null ? data.count : results.length,
          page: data.page != null ? data.page : 1,
          num_pages: data.num_pages != null ? data.num_pages : 1,
        };
      })
    );
  }
}
